import { useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { UserCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const User = () => {
  const { userId } = useTypedParams(routes.portal.users.user);
  const navigate = useNavigate();

  const handleDeleteSuccess = () => {
    navigate(routes.portal.users.$path(), {
      viewTransition: true,
      replace: true,
    });
  };

  const handleUpdateUserSuccess = () => {
    navigate(routes.portal.users.$path(), {
      viewTransition: true,
    });
  };

  return (
    <UserCard
      userId={userId}
      onDeleteSuccess={handleDeleteSuccess}
      onUpdateUserSuccess={handleUpdateUserSuccess}
    />
  );
};
